var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingPeaks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.786,
    height: 62.085,
    fill: "none",
    viewBox: "0 0 64.786 62.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#3177ff",
    clipPath: "url(#a)",
    transform: "translate(2.198 2.644)scale(.33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.612 56.54H47.98L36.818 82.281h19.68zm55.767-6.304-21.412 48.597h19.631l21.462-48.597ZM101.63 33.684H81.998l-34.692 78.959h19.68zM96.289 56.54l-34.643 78.957h19.631l34.692-78.958z",
    style: {
      fill: "#fff"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h177.053v177.053H0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingPeaks);
export default __webpack_public_path__ + "static/media/trainingPeaks.0f79681d88cc6b154e1a7bc29cb0d8d0.svg";
export { ForwardRef as ReactComponent };